module.exports = __webpack_public_path__ + "img/PencilSimpleLine.baff089b.svg";